import {apiRegister} from '../../common/api'
import {isArray, sPlain, forEach, isPlain} from '../../utils/base'
import { ERR_DATA_NOT_LIST, ERR_REP_NOT_PLAIN } from '../../const/index'

/**
 * 声明接口：updown.next.transdatelist
 * 获取一段时间内的交易日
 */

export const updownTansdateList = apiRegister('updownTansdateList', {
    path : '/award/updown2016/transdatelist/',
    checkResult: function(R) {
        return 0
    },
    formatResult (R){
        return R
    }
}).send

/**
 * 获取的我竞猜结果
 * 说明
 * 获取我的下注详情，可用作检测是否已经押过注
 * 请求参数
 * 参数名称	参数类型	说明
 * pid	int	（可选）押注的期数默认为1
 * transDate	date	押注日期
 */
export const updownMyBetinfo = apiRegister('updownMyBetinfo', {
    path : '/award/updown2016/getmybetinfo/',
    checkResult: function(R) {
        return 0
    },
    formatResult (R){
        return R
    }
}).send

/**
 * 声明接口：updown.gam.status
 * 判断是否登录,  获取我的下注详情
 */
export const updownGamStatus = apiRegister('updownGamStatus', {
    path : '/award/updown2016/betdetail/',
    checkResult: function(R) {
        return 0
    },
    formatResult (R){
        return R
    }
}).send

/**
 * 声明接口：updown.gam.up
 * 押涨下注
 */

export const updownGamUp = apiRegister('updownGamUp', {
    path : '/award/updown2016/betadd/',
    checkResult: function(R) {        
        return 0
    },
    formatResult (R){
        return R
    }
}).send

/**
 * 声明接口：updown.recent.gamInfo
 * 首页底部：近期竞猜最终结果 接口
 */
export const updownRecentGamInfo = apiRegister('updownRecentGamInfo', {
    path : '/award/updown2016/transactionlist/',
    checkResult: function(R) {        
        return 0
    },
    formatResult (R){
        return R
    }
}).send


/**
 * 声明接口：updown.init.daysumary
 * 获取每天总的金币数
 */

export const updownDaySumary = apiRegister('updownDaySumary', {
    path : '/award/updown2016/daysumary/',
    checkResult: function(R) {        
        return 0
    },
    formatResult (R){
        return R
    }
}).send

/**
 * 声明接口：shanghai.composite.index
 * 首页：上证综合指数
 */
export const shanghaiComposite = apiRegister('shanghaiComposite', {
    // send : makeSendJSONP("/award/updown2016/getstockindex/"),
   //send :  "https://"+CONST.HOST_API_MCMS+"/quotation/real_index_data",
   host: 'api-mcms',
   path :  '/quotation/real_index_data',
   check : function(query, reson) {
       return query;
   },
    formatResult: function(R) {
        if(!R.error_code && R.data.length > 0) {
            //开始格式化数据结果
            let shangzheng = {
                'currentPrice' : R.data[0].last_px,
                'diffMoney' : R.data[0].px_change,
                'diffRate' : R.data[0].px_change_rate,
                'openPrice' : R.data[0].open_px,
                'yestodayClosePrice' : R.data[0].preclose_px
            }
            R.shangzheng = shangzheng;
        }
        return R
    }
}).send

/**
 * 声明接口：person.all.money
 * 论坛我的金币
 */
export const discuzUserstats = apiRegister('discuzUserstats', {
    path : '/discuz/userstats/',
    checkResult: function(R) {
        return 0
    },
    formatResult (R){

    }
      
}).send

/**
 * 获取个人押涨跌的列表
 * @link https://splat-dev.pydp888.com/home/project/service/?pid=6&sid=3&surl=/show/&protoId=157
 * 声明接口：person.all.money
 * uid	int	用户id号
 * beforeId	int	
 * afterId	int	
 * start	int	分页参数从哪一页开始默认为0
 * pageNum	int	每页的数量
 * rewardFlag	int	0表示未进行奖励1表示已进行奖励2表示全部（默认为2）
 * 论坛我的金币
 */
export const myBetList = apiRegister('myBetList', {
    path : '/award/updown2016/betlist/',
    checkResult: function(R) {
        if(!isArray(R.list)){
            return ERR_DATA_NOT_LIST
        }
        return 0
    },
    formatResult (R){
        return R
    }      
}).send

/**
 * 获取个人押涨跌的列表
 * @link https://splat-dev.pydp888.com/home/project/service/?pid=6&sid=3&surl=/show/&protoId=157
 * 声明接口：person.all.money
 * uid	int	用户id号
 * beforeId	int	
 * afterId	int	
 * start	int	分页参数从哪一页开始默认为0
 * pageNum	int	每页的数量
 * rewardFlag	int	0表示未进行奖励1表示已进行奖励2表示全部（默认为2）
 * 论坛我的金币
 */
export const mytRecordInfo = apiRegister('mytRecordInfo', {
    path : '/award/updown2016/getmyrecord/',
    checkResult: function(R) {
        if(!isPlain(R.info)){
            return ERR_DATA_NOT_OBJECT
        }
        return 0
    },
    formatResult (R){
        return R
    }      
}).send

